import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useSearchActions, useSearchResults, useSearchState } from '#src/app/pages/searchV2/shared/searchState';

type TrackingContext = 'status_filter_trending' | 'status_filter_all' | 'status_filter_victories';

type Result = ModelHookResult<
	{
		disabled: boolean;
		isAllPetitionsChecked: boolean;
		isVictoriesOnlyChecked: boolean;
		isTrendingChecked: boolean;
	},
	{
		setAllPetitions: () => void;
		setVictoriesOnly: () => void;
		setTrending: () => void;
		trackStatusFilterClick: (context: TrackingContext) => void;
	}
>;

export function useStatusFilter(): Result {
	const state = useSearchState();
	const results = useSearchResults();
	const actions = useSearchActions();
	const track = useTracking();

	const trackStatusFilterClick = useCallback(
		(context: TrackingContext) => {
			void track('search', {
				context,
				q: state.query || '',
			});
		},
		[state.query, track],
	);

	return {
		data: {
			disabled: results.isLoading,
			isAllPetitionsChecked: state.status === 'all',
			isVictoriesOnlyChecked: state.status === 'victory',
			isTrendingChecked: state.status === 'trending',
		},
		actions: {
			setAllPetitions: useCallback(() => {
				actions.setStatus('all');
			}, [actions]),
			setVictoriesOnly: useCallback(() => {
				actions.setStatus('victory');
			}, [actions]),
			setTrending: useCallback(() => {
				actions.setStatus('trending');
			}, [actions]),
			trackStatusFilterClick,
		},
	};
}
